import React from 'react'

import BaseButton from '../base/base_button'

const SecondaryButton = props => (
	<BaseButton
		{...props}
		bgColor='green'
		fontColor='white' />
)

export default SecondaryButton
